import { FunctionComponent, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { IGlossaryFileSupportExtended } from "../../../../../features/translation/TranslationHeader/GlossarySelection/GlossarySelection.types";
import { translationKeys } from "../../../../../models/app-translation-keys";
import { useGlossaryService } from "../../../../../services/ServiceHooks/glossaryHook";
import { sharedDialog } from "../../../../Shared/Components/Dialogs/SharedDialog";
import { ManageGlossaryDialogContent } from "./ManageGlossaryDialogContent/ManageGlossaryDialogContent";
import { manageGlossaryDialogFooterActions } from "./manageGlossaryDialogFooterActions";
import { IManageGlossaryDialogState } from "./manageGlossaryDialogTypes";

export interface IAddEditGlossaryDialogProps {
  glossary?: IGlossaryFileSupportExtended;
  isVisible: boolean;
  onHide(success?: boolean): void;
}

const GLOSSARY_NAME_MIN_LENGTH = 3;

export const ManageGlossaryDialog: FunctionComponent<IAddEditGlossaryDialogProps> = (
  props: IAddEditGlossaryDialogProps,
) => {
  const { t } = useTranslation();
  const glossaryService = useGlossaryService();

  const uploadTranslationKeys = translationKeys.adminArea.glossary;

  useEffect(() => {
    if (!props.isVisible) {
      return;
    }

    const glossaryName: string = props.glossary?.name ?? "";
    const glossaryDescription: string = props.glossary?.description ?? "";

    sharedDialog.openSharedDialog({
      title: t(
        props.glossary
          ? uploadTranslationKeys.dialog.headerUpdateGlossary
          : uploadTranslationKeys.dialog.headerCreateGlossary,
      ),
      size: "small",
      onClose: () => props.onHide(),
      sharedState: {
        glossaryName: glossaryName,
        glossaryDescription: glossaryDescription,
        glossaryFile: null,
        isUploading: false,
        isDisabled: (props.glossary ? props.glossary.name : "").length < GLOSSARY_NAME_MIN_LENGTH,
      } satisfies IManageGlossaryDialogState,
      customContent: <ManageGlossaryDialogContent minNameLength={GLOSSARY_NAME_MIN_LENGTH} />,
      footerActions: manageGlossaryDialogFooterActions({
        updateGlossaryMetadata: async request => glossaryService.updateGlossaryMetadata(request),
        uploadGlossaryFile: async request => glossaryService.uploadGlossaryFile(request),
        glossary: props.glossary,
        onHide: props.onHide,
        isEdit: Boolean(props.glossary),
      }),
      className: "manage-glossary-dialog",
      customDismissBehavior: { closeIcon: true, escape: false, outsideClick: false },
    });
  }, [props.isVisible]);

  return null;
};
